import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { CalendarPlus, ClipboardCheck } from "lucide-react";

const STAGE_LABEL = { nuovo: "Non contattato", contattato: "Primo contatto", qualificato: "Parlato col decision maker", trattativa: "Incontro" };

export default function ProspectRecontactDialog({ open, onOpenChange, items = [], onNuovaAttivita, onRegistraVisita }) {
  const t = new Date().toISOString().slice(0, 10);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="prospect-recontact-dialog">
        <DialogHeader>
          <DialogTitle>Prospect da ricontattare ({items.length})</DialogTitle>
          <DialogDescription>Prospect con ricontatto scaduto in base allo stadio del funnel e alle attività registrate.</DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] space-y-2 overflow-y-auto pr-1">
          {items.length === 0 && <p className="py-8 text-center text-sm text-muted-foreground">Nessun prospect da ricontattare.</p>}
          {items.map((p) => {
            const days = Math.round((new Date(t) - new Date(String(p.next_action_date).slice(0, 10))) / 86400000);
            const cls = days > 7 ? "border-red-500/40 text-red-400" : days > 0 ? "border-amber-500/40 text-amber-400" : "border-primary/40 text-primary";
            return (
              <div key={p.id} className="flex items-center justify-between gap-3 rounded-md border border-white/10 bg-black/30 p-2.5 text-sm" data-testid={`recontact-${p.id}`}>
                <div className="min-w-0">
                  <Link to={`/prospect/${p.id}`} onClick={() => onOpenChange(false)} className="truncate font-semibold text-primary hover:underline" data-testid={`recontact-link-${p.id}`}>{p.name}</Link>
                  <div className="truncate text-[11px] text-muted-foreground">
                    {STAGE_LABEL[p.stage] || p.stage}{p.city ? ` · ${p.city}` : ""}{p.agency_name ? ` · ${p.agency_name}` : ""}
                  </div>
                </div>
                <div className="flex shrink-0 items-center gap-1.5">
                  <Badge variant="outline" className={`text-[10px] ${cls}`}>
                    {p.next_action || "Ricontatto"} · {days > 0 ? `${days}gg fa` : "oggi"}
                  </Badge>
                  <Button size="sm" variant="ghost" className="h-7 px-2 text-xs" onClick={() => onNuovaAttivita?.({ kind: "prospect", id: p.id, name: p.name })} data-testid={`recontact-attivita-${p.id}`}>
                    <CalendarPlus className="mr-1 h-3.5 w-3.5" /> Nuova attività
                  </Button>
                  <Button size="sm" variant="ghost" className="h-7 px-2 text-xs" onClick={() => onRegistraVisita?.({ kind: "prospect", id: p.id, name: p.name })} data-testid={`recontact-visita-${p.id}`}>
                    <ClipboardCheck className="mr-1 h-3.5 w-3.5" /> Registra visita
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
